import { render, staticRenderFns } from "./ViewMore.vue?vue&type=template&id=3b698874&scoped=true&"
var script = {}
import style0 from "./ViewMore.vue?vue&type=style&index=0&id=3b698874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b698874",
  null
  
)

export default component.exports